import React, { memo, useCallback, useMemo, useRef, useState } from "react";

import MetaTitle from "../../../../components/MetaTitle";
import AuthLogin from "../AuthLogin";
import AuthRegistration from "../AuthRegistration";
import AuthForgotPassword from "../AuthForgotPassword";
import Notification from "../../../../components/UI/Notification";

import { Container } from "./styles";

const AuthForm = () => {
  const hasRedirected = useRef(false);
  const [activeTab, setActiveTab] = useState("sign-in");

  const changeTab = useCallback((name) => setActiveTab(name), []);

  const tabs = useMemo(
    () => ({
      "sign-in": () => (
        <AuthLogin changeTab={changeTab} hasRedirected={hasRedirected} />
      ),
      "sign-up": () => <AuthRegistration changeTab={changeTab} />,
      "forgot-password": () => <AuthForgotPassword changeTab={changeTab} />,
    }),
    [changeTab],
  );

  const tab = useMemo(() => tabs?.[activeTab]?.(), [activeTab, tabs]);

  return (
    <Container>
      <MetaTitle title="Register Free Account" />
      <Notification />
      {tab}
    </Container>
  );
};

export default memo(AuthForm);
